export default __webpack_public_path__ + "c83848626340b9078f9933ed2c843f60.svg";